module.exports = __webpack_public_path__ + "static/media/girl_01_mouth_close.182fc55c.png";